export default __webpack_public_path__ + "static/media/attachment-icon.539b4aa9.svg";